var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "news_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 8h45.917v38.667h4.833v-21.75H61v31.416H3zm9.667 9.667v14.5H39.25v-14.5zM38.646 44.25H13.27v-4.833h25.375z",
    clipRule: "evenodd"
  })));
};
export { SvgNews as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMgOEg0OC45MTY3VjQ2LjY2NjdINTMuNzVWMjQuOTE2N0g2MVY1Ni4zMzMzSDNWOFpNMTIuNjY2NyAxNy42NjY3VjMyLjE2NjdIMzkuMjVWMTcuNjY2N0gxMi42NjY3Wk0zOC42NDU4IDQ0LjI1SDEzLjI3MDhWMzkuNDE2N0gzOC42NDU4VjQ0LjI1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";